// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__TSEGu","image_wrapper":"Hero_image_wrapper__nd9Dq","headline":"Hero_headline__lKLhL","product_image":"Hero_product_image__p4eCk"};